import styled from "styled-components";
import { components } from "react-select";

const hoverStyle = "0px 0px 0px 3px rgba(67, 130, 247, 0.3)";

export const customStyles = {
  control: (css, state) => ({
    ...css,
    backgroundColor: "white",
    border: "1px solid #d0d5dd",
    borderColor: state.selectProps.menuIsOpen ? "#4382f7" : "#d0d5dd",
    borderRadius: "6px",
    boxShadow: state.selectProps.menuIsOpen ? hoverStyle : "none",
    cursor: "pointer",
    ":hover": { boxShadow: hoverStyle }
  }),
  valueContainer: (css, state) => ({
    ...css,
    position: "relative",
    overflow: "initial",
    padding: "6px 16px 6px 16px",
    justifyContent: "space-between",
    "> svg": {
      transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.25s cubic-bezier(0, 0, 0.25, 1)"
    }
  }),
  input: () => ({
    position: "absolute",
    left: "63px",
    fontSize: "14px"
  }),
  multiValue: () => ({
    display: "none"
  }),
  menu: (css) => ({
    ...css,
    flexDirection: "row",
    border: "1px solid #d0d5dd",
    borderRadius: "6px",
    boxShadow: "0px 4px 10px rgba(21, 22, 51, 0.15)",
    top: "48px",
    right: "0",
    width: "686px",
    overflow: "hidden"
  }),
  menuList: (css) => ({
    ...css,
    padding: "8px",
    "div:last-child": {
      marginBottom: "0"
    }
  }),
  option: (css, state) => ({
    cursor: "pointer",
    padding: "8px",
    borderRadius: "6px",
    marginBottom: "8px",
    backgroundColor: state.isSelected ? "#4382f7" : "white",
    ":hover": {
      backgroundColor: state.isSelected ? "#4382f7" : "#deebff"
    },
    p: {
      color: state.isSelected ? "white" : "#1d2939"
    }
  })
};

export const Selector = styled.div`
  margin-bottom: 24px;
`;

export const Label = styled.p`
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #1d2939;

  margin-bottom: ${(props) => (props.margin ? "14px" : "4px")};
`;

export const Description = styled.div`
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #98a2b3;
  margin-bottom: 14px;
`;

export const AddMemberOption = styled(components.NoOptionsMessage)`
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  &:hover {
    background-color: #deebff;
  }
  div {
    text-align: left;
  }
`;
